var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{attrs:{"name":"top_head"},on:{"change_project":_vm.change_pro}}),_c('router-view',{attrs:{"name":"left"}}),(_vm.isRouterAlive)?_c('router-view',{attrs:{"name":"content"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }